import React from 'react';
import { classes } from '../CUtil';

const OurLogo = (props) => {
	const cls = classes("ad_navbar_brand_logo", props.className);
	let alt, src;
	const dark = !!props.dark;

	if (IS_AKTIEDYSTEN_DK) {
		alt = "Aktiedysten";;
		src = dark ? "https://static.aktiedysten.dk/gfx/aktiedysten-logo-5-dark.svg" : "https://static.aktiedysten.dk/gfx/aktiedysten-logo-4-hvid.svg";
	} else if (IS_AKTIEKAMPEN_SE) {
		alt = "Aktiekampen";
		src = dark ? "https://static.aktiedysten.dk/gfx/aktiekampen-logo-0-dark.svg" : "https://static.aktiedysten.dk/gfx/aktiekampen-logo-0-hvid.svg";
	} else if (IS_INVESTSPIEL_DE) {
		alt = "Investspiel";
		src = dark ? "https://static.aktiedysten.dk/gfx/investspiel-logo-0-dark.svg" : "https://static.aktiedysten.dk/gfx/investspiel-logo-0-hvid.svg";
	} else if (IS_TRADERR_COM) {
		alt = "Traderr";
		src = dark ? "https://static.aktiedysten.dk/gfx/traderr-logo-dark-0.svg" : "https://static.aktiedysten.dk/gfx/traderr-logo-white-0.svg";
	}
	return <img alt={alt} className={cls} src={src}/>;
}

export default OurLogo;



// WEBPACK FOOTER //
// ./src/c/OurLogo.js